import { useState, useEffect } from 'react'
import { detectPwaLaunch } from '@lib/utils/pwa'

const useIsPWA = (): boolean => {
    const [isPWA, setIsPWA] = useState(false)

    useEffect(() => {
        if (typeof window === 'undefined') return

        const mediaQuery = window.matchMedia('(display-mode: standalone)')
        const syncPwaState = () => {
            setIsPWA(detectPwaLaunch())
        }

        syncPwaState()

        mediaQuery.addEventListener('change', syncPwaState)
        window.addEventListener('pageshow', syncPwaState)
        window.addEventListener('focus', syncPwaState)
        document.addEventListener('visibilitychange', syncPwaState)

        return () => {
            mediaQuery.removeEventListener('change', syncPwaState)
            window.removeEventListener('pageshow', syncPwaState)
            window.removeEventListener('focus', syncPwaState)
            document.removeEventListener('visibilitychange', syncPwaState)
        }
    }, [])

    return isPWA
}

export default useIsPWA
